import { render, staticRenderFns } from "./TwAddDocuments.vue?vue&type=template&id=5999757f&"
import script from "./TwAddDocuments.vue?vue&type=script&lang=js&"
export * from "./TwAddDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TwAddDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports